// 取消请求封装
export default function cancel(self) {
    self.prototype.addCancel = function(name) {
        return function (fun) {
            self[`_${name}RequestCancel`] = fun;
        };
    };

    self.prototype.doCancel = function (name) {
        if (self[`_${name}RequestCancel`]) {
            self[`_${name}RequestCancel`]();
            self[`_${name}RequestCancel`] = null;
        }
    };
}



// WEBPACK FOOTER //
// ./src/utils/cancel.js